import { render, staticRenderFns } from "./Collectif.vue?vue&type=template&id=d08e1500&"
import script from "./Collectif.vue?vue&type=script&lang=js&"
export * from "./Collectif.vue?vue&type=script&lang=js&"
import style0 from "./Collectif.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports